export const decodeBlob = (blob: Blob): Promise<ImageBitmap> => createImageBitmap(blob);

export const releaseBitmap = (bitmap: ImageBitmap): void => bitmap.close();

export const isBitmapUsable = (bitmap: ImageBitmap): boolean => bitmap.width > 0 && bitmap.height > 0;

export const drawBitmap = (canvas: HTMLCanvasElement, bitmap: ImageBitmap): void => {
    if (!isBitmapUsable(bitmap)) {
        return;
    }
    const target = canvas;
    target.width = bitmap.width;
    target.height = bitmap.height;
    target.getContext('2d')?.drawImage(bitmap, 0, 0);
};
